import Button from '../../components/Button';
import Element from '../../components/element';
import Flex from '../../components/flex';
import Text from '../../components/text';
import React from 'react';
import { colors } from '../../config/theme';
import useStyles from './style';

const CancelAppointment = props => {
  const classes = useStyles();
  const {
    onClose,
    onReschedule,
    question,
    desc,
    confirmText,
    reschedule,
    onCancel
  } = props;

  return (
    <Element>
      <hr />
      <Text family="GTAM" type="h5" marginTop="24px">
        {question}
      </Text>
      {desc}
      <Flex justify="space-between" marginTop="40px">
        <Button
          scheme="light"
          onClick={onClose}
          style={{
            borderColor: colors.dustyGray,
            color: colors.dustyGray
          }}
          className={classes.hoverDisable}
        >
          Cancel
        </Button>
        {reschedule && (
          <Button
            scheme="dark"
            className={`${classes.hoverDisable} ${classes.marginLeft15}`}
            onClick={onReschedule}
          >
            Reschedule Instead
          </Button>
        )}
        <Button
          style={{
            backgroundColor: colors.ceriseRed,
            borderColor: colors.ceriseRed,
            color: 'white'
          }}
          className={classes.hoverDisable}
          onClick={onCancel}
        >
          {confirmText}
        </Button>
      </Flex>
    </Element>
  );
};

export default CancelAppointment;
